import { render, staticRenderFns } from "./ResearchGenesTrack.vue?vue&type=template&id=7bd9bd60"
import script from "./ResearchGenesTrack.vue?vue&type=script&lang=js"
export * from "./ResearchGenesTrack.vue?vue&type=script&lang=js"
import style0 from "./ResearchGenesTrack.vue?vue&type=style&index=0&id=7bd9bd60&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd9bd60')) {
      api.createRecord('7bd9bd60', component.options)
    } else {
      api.reload('7bd9bd60', component.options)
    }
    module.hot.accept("./ResearchGenesTrack.vue?vue&type=template&id=7bd9bd60", function () {
      api.rerender('7bd9bd60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchGenesTrack.vue"
export default component.exports